import { memo } from 'react';
import { Square, SquareCheck } from 'lucide-react';
import styles from './SiteScheduleCheckbox.module.css';

export default memo(function SiteScheduleCheckbox({ siteSchedule, onSelect }) {
  const name = `select-${siteSchedule.site_name}-${siteSchedule.schedule_name}`;
  const id = `site-field-id-${siteSchedule.key}`;

  const handleSelection = (e) => {
    onSelect(siteSchedule.key, e.target.checked);
  };

  return (
    <label className={`${styles.label} d-flex`} htmlFor={id}>
      <div className={styles.checkboxIcon}>
        <Square size={16} strokeWidth={2} className={styles.unchecked} aria-hidden />
        <SquareCheck size={16} strokeWidth={2} className={styles.checked} aria-hidden />
      </div>
      <div className="d-flex justify-content-between w-100">
        <div className="d-flex flex-column p-2 ps-1">
          <input
            id={id}
            type="checkbox"
            name={name}
            value={siteSchedule.key}
            className="d-none"
            data-existing="true"
            checked={!!siteSchedule.selected}
            onChange={handleSelection}
          />
          <strong>{siteSchedule.site_name}</strong>
        </div>
      </div>
    </label>
  );
});
